import { StudentResponseDto } from "../shared/dtos/student/StudentResponseDto";
import { StudentSummaryDto } from "../shared/dtos/student/StudentSummaryDto";

export class StudentMapper {
  public static mapStudentToSummary(
    detailedStudent: StudentResponseDto,
  ): StudentSummaryDto {
    return {
      id: detailedStudent.id,
      studentId: detailedStudent.studentId,
      firstName: detailedStudent.firstName,
      middleName: detailedStudent.middleName,
      lastName: detailedStudent.lastName,
      gender: detailedStudent.gender,
      branchId: detailedStudent.branchId,
      branchName: detailedStudent.branchName,
    };
  }
}

export const mapStudentToSummary = StudentMapper.mapStudentToSummary;
